const stateSelector = state => state.settings

const settingSelectorFactory = setting => createSelector(stateSelector, state => (state ? state[setting] : null))

const arrayFromCsv = csv => (csv == null ? [] : csv.split(',').map(val => val.trim()))

const googleAnalyticsIdSettingSelector = settingSelectorFactory('google_analytics_id')
export const googleTagManagerIdSelector = settingSelectorFactory('google_tag_manager_id')
export const googleAnalyticsIdsSelector = createSelector(googleAnalyticsIdSettingSelector, setting =>
    arrayFromCsv(setting)
)
export const googleTrackersSelector = createSelector(googleAnalyticsIdsSelector, ids =>
    ids.reduce((trackers, id, index) => {
        trackers[id] = index > 0 ? `tracker${index}` : null

        return trackers
    }, {})
)

const googleAnalyticsLinkedDomainsSettingsSelector = settingSelectorFactory('google_analytics_linked_domains')
export const googleAnalyticsLinkedDomainsSelector = createSelector(
    googleAnalyticsLinkedDomainsSettingsSelector,
    domains => arrayFromCsv(domains)
)

export const rdAnalyticsUrlSelector = settingSelectorFactory('rd_analytics_url')
export const iosAppUrlSelector = settingSelectorFactory('ios_app_url')
export const androidAppUrlSelector = settingSelectorFactory('android_app_url')

export const unbookableBtnTypeSelector = settingSelectorFactory('unbookable_btn_type')
export const unbookableBtnUrlSelector = settingSelectorFactory('unbookable_btn_url')

export const companySelector = settingSelectorFactory('company')
export const companyAddressSelector = settingSelectorFactory('company_address')

export const startOfWeekSelector = createSelector(settingSelectorFactory('start_of_week'), value => parseInt(value))
